// AuthorPage.jsx
import React, {
  FC,
  Fragment,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Tab } from "@headlessui/react";
import { Helmet } from "react-helmet-async";
import axios from "axios";

import Breadcrumb from "./Breadcrumb";
import Bio from "components/Text/Bio";
import View from "components/LikeDislikeSubcribe/View";
import Subscriber from "components/LikeDislikeSubcribe/Subscriber";
import Royalty from "components/LikeDislikeSubcribe/Royalty";
import Comments from "components/LikeDislikeSubcribe/Comments";
import StayCard from "components/StayCard/StayCard";
import ExperiencesCard from "components/ExperiencesCard/ExperiencesCard";
import ButtonSecondary from "shared/Button/ButtonSecondary";
import Button from "shared/Button/Button";
import Loading from "components/Loading/Loading";
import LoyaltyRewards from "./LoyaltyRewards";
import OperatorCoverHeader from "./OperatorCoverHeader";

import { DEMO_EXPERIENCES_LISTINGS, DEMO_STAY_LISTINGS } from "data/listings";

import {
  FiCheckCircle,
  FiPlusCircle,
  FiRefreshCw,
  FiShare2,
} from "react-icons/fi";
import { baseURL, socketId } from "configs/axiosConfig";
import { format } from "timeago.js";
import chatApi from "api/chat/chat.api";
import { setAuthModalOpen } from "../../redux/features/authModalSlice";
import { RootState } from "../../redux/store";
import HeroSection from "./component/HeroSection";
import ServicesSection from "./component/ServicesSection";
import TeamSection from "./component/TeamSection";
import ReviewsSection from "./component/ReviewSection";
import BuySection from "./component/BuySection";
import AboutSection from "./component/AboutSection";
import StickyInfoBox from "./component/StickyInfoBox";
import ShareModal from "components/ShareLink/ShareModal";
import menuApi from "api/menu/menu.api";
import MenuListDirect from "./component/MenuListDirect";
import sericesApi from "api/service/service.api";
import { toast } from "react-toastify";
import staffApi from "api/staff/staff.api";
import operatorApi from "api/operator/operator.api";
import usePageSEO from "components/SEO/UsePageSEO";
// import ShareModal from "components/ShareLink/ShareModal";

const AuthorPage = () => {
  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { slug } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [isDataLoading, setIsDataLoading] = useState(true); // Second stage loading

  const [operator, setOperator] = useState([]);
  const [CommentLists, setCommentLists] = useState([]);
  const [follows, setFollows] = useState(0);
  const [joinRoyalNumber, setJoinRoyalNumber] = useState(0);
  const [onlineUsers, setOnlineUsers] = useState([]);

  const [menuCategories, setMenuCategories] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [modalItem, setModalItem] = useState(null); // NEW STATE
  const [selectedCategoryId, setSelectedCategoryId] = useState(
    menuCategories[0]?._id
  );

  const [services, setServices] = useState([]);
  const [serviceCategory, setServiceCategory] = useState([]);
  const [staffs, setStaffs] = useState([]);

  //------------------------ menu top section-------------------------

  const [showSticky, setShowSticky] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  const [showShare, setShowShare] = useState(false); // ✅ must be here

  // Scroll to section
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  //------------------------ menu top section-------------------------

  const getOperator = async () => {
    try {
      const data = await operatorApi.getOperatorBySlug(slug);

      const operatorData = Array.isArray(data) ? data : [data]; // keep same array format

      setOperator(operatorData);
    } catch (error) {
      toast.error(`Error fetching operator by slug: ${error.message}`);
    } finally {
      setIsLoading(false);
    }
  };

  // console.log({ operator });

  const id = operator[0]?._id;
  // SEO Always call at top level — no condition
  // usePageSEO(operator[0] || null);

  const getReviewList = async () => {
    const res = await axios.post(`${baseURL}/api/review/getReviews`, {
      videoId: id,
    });
    if (res.data.success) setCommentLists(res.data.reviews);
  };

  const getFollowers = async () => {
    const userTo = id;
    const userFrom = user?._id;
    try {
      const subNum = await axios.post(
        `${baseURL}/api/subscribe/subscribeNumber`,
        { userTo }
      );
      if (subNum.data.success) setFollows(subNum.data.subscribeNumber);

      const subbed = await axios.post(`${baseURL}/api/subscribe/subscribed`, {
        userTo,
        userFrom,
      });
      if (subbed.data.success) {
        /* do nothing */
      }
    } catch (err) {
      console.error("Error fetching followers:", err);
    }
  };

  const getRoyalty = async () => {
    const joinCount = await axios.post(
      `${baseURL}/api/royalprogram/joinNumber`,
      { userTo: id }
    );
    if (joinCount.data.success) setJoinRoyalNumber(joinCount.data.joinNumber);
  };

  const getMenuCategories = async () => {
    try {
      const response = await menuApi.getMenuCategory({ operator: id });
      if (response.success && response.category) {
        setMenuCategories(response.category);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getMenuItems = async () => {
    try {
      const response = await menuApi.getMenuItems({ operator: id });
      // Ensure menuItems is an array before setting state
      if (response?.success) {
        let menuItems = response.menuItems;

        // console.log({ menuItems });

        if (!Array.isArray(menuItems)) {
          // If `menuItem` is an object, wrap it in an array
          menuItems = menuItems ? [menuItems] : [];
        }

        setMenuItems(menuItems);
      } else {
        console.warn("Unexpected response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching menu items:", error);
    }
  };

  const getServicelData = async () => {
    try {
      const operatorId = operator[0]?._id;

      const { response, err } = await sericesApi.getallService({ operatorId });

      if (response && response.data) {
        setServices(response.data.services);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };

  const getServiceCategories = async () => {
    try {
      const operatorId = operator[0]?._id;

      const response = await sericesApi.getServiceCategory({
        operator: operatorId,
      });
      if (response.success && response.category) {
        setServiceCategory(response.category);
      }
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getAllStaff = async () => {
    try {
      const operatorId = operator[0]?._id;

      const { response, err } = await staffApi.getAllStaffInfo(operatorId);

      if (response && response.data) {
        setStaffs(response.data.data);
      } else {
        toast.error("No data found");
      }
    } catch (error) {
      toast.error("Something went wrong!");
      console.error("Error fetching data:", error);
    }
  };
  // console.log({ staffs });

  // console.log({ services });
  // console.log({ serviceCategory });

  useEffect(() => {
    const startTime = Date.now();
    setIsLoading(true);

    const loadBaseData = async () => {
      try {
        await Promise.all([
          getOperator(),
          getReviewList(),
          getFollowers(),
          getRoyalty(),
        ]);
      } catch (err) {
        console.error("Error loading base data:", err);
      }
    };

    loadBaseData().finally(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, 200 - elapsed);
      setTimeout(() => setIsLoading(false), remaining);
    });
  }, []);

  useEffect(() => {
    if (!operator?.[0]?._id) return;

    const startTime = Date.now();
    setIsDataLoading(true);

    const loadOperatorData = async () => {
      try {
        if (operator[0].operatorType === "booking") {
          await Promise.all([
            getServicelData(),
            getServiceCategories(),
            getAllStaff(),
          ]);
        } else {
          await Promise.all([getMenuCategories(), getMenuItems()]);
        }
      } catch (err) {
        console.error("Error loading operator data:", err);
      }
    };

    loadOperatorData().finally(() => {
      const elapsed = Date.now() - startTime;
      const remaining = Math.max(0, 200 - elapsed);
      setTimeout(() => setIsDataLoading(false), remaining);
    });
  }, [operator]);

  const isPageLoading = isLoading || isDataLoading;

  const SECTIONS = useMemo(
    () => [
      "services",
      ...(operator?.[0]?.operatorType === "booking" && staffs?.length > 0
        ? ["team"]
        : []),
      ...(operator?.[0]?.hasLoyalty ? ["loyalty"] : []),

      "reviews",
      "about",
    ],
    [operator, staffs]
  );

  useEffect(() => {
    if (user?._id) {
      socketId.emit("addUser", user._id);
      socketId.on("getUsers", (data) => setOnlineUsers(data));
    } else {
      dispatch(setAuthModalOpen(true));
    }
  }, [user]);

  const heroRef = useRef();

  useEffect(() => {
    const handleScroll = () => {
      const scrollThreshold = 80; // 80mm in pixels ≈ 302.4px
      setShowSticky(window.scrollY > scrollThreshold);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const sectionIds = SECTIONS;
    const observers = [];

    const tryObserveSections = () => {
      const allReady = sectionIds.every((id) => document.getElementById(id));

      if (!allReady) {
        requestAnimationFrame(tryObserveSections);
        return;
      }

      sectionIds.forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;

        const observer = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              setActiveSection(id);
              console.log("🟢 Visible section:", id);
            }
          },
          {
            rootMargin: "-30% 0px -60% 0px",
            threshold: 0.1,
          }
        );

        observer.observe(el);
        observers.push(observer);
      });
    };

    tryObserveSections();

    return () => observers.forEach((observer) => observer.disconnect());
  }, [SECTIONS]); // ✅ React will re-run when sections change

  useEffect(() => {
    console.log("Active section changed:", activeSection);
  }, [activeSection]);

  const categoryButtonRefs = useRef({});

  useEffect(() => {
    const activeEl = categoryButtonRefs.current[activeSection];
    if (activeEl) {
      activeEl.scrollIntoView({
        behavior: "smooth",
        inline: "start",
        block: "nearest",
      });
    }
  }, [activeSection]);

  if (!user) return null;

  const isOperatorOnline = onlineUsers.some(
    (u) => u.userId === operator[0]?._id
  );

  const handleMessageSubmit = async () => {
    try {
      await chatApi.createNewConversation({
        groupTitle: `${operator[0].name} & ${user?.displayName}`,
        userId: user?._id,
        sellerId: operator[0]._id,
      });
      navigate("/userInbox");
    } catch (error) {
      console.error("Error creating conversation:", error);
    }
  };

  const updateComment = (newComment) =>
    setCommentLists([...CommentLists, newComment]);
  const updateSubcribe = (newSub) => setFollows(newSub);
  const updateRoyalty = (newJoinCount) => setJoinRoyalNumber(newJoinCount);

  const calculateAverageRating = (reviews) => {
    const validRatings = reviews.filter((r) => typeof r.rate === "number");
    if (validRatings.length === 0) return "0.0";
    const total = validRatings.reduce((sum, r) => sum + r.rate, 0);
    return (total / validRatings.length).toFixed(1);
  };

  const averageRating = calculateAverageRating(CommentLists);

  return (
    <div className="nc-AuthorPage">
      <Helmet>
        <title>{`Booking | ${operator[0]?.name || ""}`}</title>
        <meta name="description" content={operator[0]?.town || ""} />
        <meta property="og:title" content={operator[0]?.title || ""} />
        <meta property="og:description" content={operator[0]?.email || ""} />
        <meta property="og:image" content={operator[0]?.photo || ""} />
      </Helmet>
      {isPageLoading ? (
        <div className="flex justify-center items-center h-[50vh]">
          <Loading />
        </div>
      ) : (
        <main className="mt-0 mb-24 lg:mb-32">
          {showSticky && (
            <>
              {/* 🔻 Mobile Header + Scrollable Tabs */}
              <div className="fixed top-0 left-0 right-0 bg-dry z-50 border-b border-border lg:hidden">
                <div className="flex items-center justify-between px-4 py-2">
                  <button className="text-xl" onClick={() => navigate("/")}>
                    ←
                  </button>
                  <h1 className="font-semibold text-white">
                    {operator[0]?.name}
                  </h1>
                  <div className="flex items-center gap-4 text-xl">
                    <button
                      onClick={() => setShowShare(true)}
                      className="text-gray-600 hover:text-black"
                    >
                      <FiShare2 size={20} />
                    </button>
                    <button>🤍</button>
                  </div>
                </div>

                <div className="overflow-x-auto  ">
                  <div className="flex gap-3 px-4 pb-2 text-sm font-medium min-w-max">
                    {SECTIONS.map((s) => {
                      const id = s.toLowerCase();
                      const isActive = activeSection === id;

                      return (
                        <button
                          key={id}
                          ref={(el) => (categoryButtonRefs.current[id] = el)}
                          onClick={() => scrollToSection(id)}
                          className={`uppercase whitespace-nowrap px-4 py-2 rounded-full   transition-all duration-200 text-sm font-semibold ${
                            isActive
                              ? " text-redlight shadow underline underline-offset-[15px]"
                              : " text-textGray hover:bg-red-600 hover:text-white"
                          }`}
                        >
                          {s}
                        </button>
                      );
                    })}
                  </div>
                </div>
              </div>

              {/* 🔺 Desktop Centered Menu */}
              <div className="fixed top-0 left-0 right-0 bg-gray-900 z-50 shadow hidden lg:block ">
                <div className="w-full max-w-screen-xl mx-auto flex justify-start px-6 py-4 gap-4 min-h-[60px]">
                  {SECTIONS.map((s) => {
                    const id = s.toLowerCase();
                    const isActive = activeSection === id;

                    return (
                      <button
                        key={id}
                        onClick={() => scrollToSection(id)}
                        className={`relative uppercase whitespace-nowrap px-4 py-1 text-sm font-semibold transition-all ${
                          isActive
                            ? "text-redlight font-bold underline underline-offset-8"
                            : "text-text hover:text-white"
                        }`}
                      >
                        {s}
                      </button>
                    );
                  })}
                </div>
              </div>
            </>
          )}
          <div className="mb-10" ref={heroRef}>
            <OperatorCoverHeader
              operator={[
                {
                  ...operator?.[0],
                  rating: averageRating,
                  reviewCount: CommentLists.length,
                },
              ]}
              isOnline={isOperatorOnline}
              follows={follows}
              joinRoyalNumber={joinRoyalNumber}
              id={id}
              user={user}
              updateSubcribe={updateSubcribe}
              updateRoyalty={updateRoyalty}
              handleMessageSubmit={handleMessageSubmit}
              CommentLists={CommentLists}
              onShareClick={() => setShowShare(true)} // ✅ PASS DOWN HERE
            />
          </div>
          <div className="container space-y-8 lg:space-y-10">
            {/* {renderSection1()} */}

            {/* Main Content + Sticky Info Box */}
            <div className=" relative flex gap-10 ">
              {/* Left Content Sections */}
              <div className="w-full lg:max-w-[calc(100%-340px)] flex flex-col sm:gap-0 gap-10">
                {SECTIONS.map((section) => (
                  <section
                    id={section}
                    key={section}
                    className={`min-h-[500px]  sm:border-0 border-border sm:rounded-0 py-20 px-0 ${
                      section === "team" || section === "buy" ? "" : ""
                    }`}
                  >
                    {section === "services" && (
                      <div className="relative h-[600px] overflow-y-auto scrollbar-thin">
                        <MenuListDirect
                          menuCategories={
                            operator[0]?.operatorType === "booking"
                              ? serviceCategory // from your services API
                              : menuCategories // from your menu API
                          }
                          menuItems={
                            operator[0]?.operatorType === "booking"
                              ? services // from your services API
                              : menuItems // from your menu API
                          }
                          selectedCategoryId={selectedCategoryId}
                          setSelectedCategoryId={setSelectedCategoryId}
                          setModalItem={setModalItem}
                          expandedCategory={undefined}
                          operatorId={operator[0]?._id}
                          operatorType={operator[0]?.operatorType}
                          operatorSlug={operator[0]?.slug}
                        />
                      </div>
                    )}
                    {section === "team" && <TeamSection staffs={staffs} />}
                    {section === "reviews" && (
                      <div id="comments-section">
                        <Comments
                          CommentLists={CommentLists}
                          postId={id}
                          refreshFunction={updateComment}
                          userFrom={user._id}
                          author={operator[0]?.name || "Loading..."}
                        />
                      </div>
                    )}
                    {section === "loyalty" && (
                      <LoyaltyRewards
                        joinRoyalNumber={joinRoyalNumber}
                        operator={operator[0]}
                        operatorId={operator[0]?._id}
                      />
                    )}
                    {section === "about" && (
                      <AboutSection operator={operator[0]} />
                    )}
                  </section>
                ))}
              </div>

              {/* Right Sticky Info Box */}
              <div className="hidden lg:block w-[300px] shrink-0 sticky top-28 h-fit ">
                <StickyInfoBox
                  operator={{
                    ...operator[0],
                    rating: averageRating,
                    reviewCount: CommentLists.length,
                  }}
                />
              </div>
            </div>
            {showShare && <ShareModal onClose={() => setShowShare(false)} />}
          </div>
        </main>
      )}
    </div>
  );
};

export default AuthorPage;
